// extracted by mini-css-extract-plugin
export default {"listCard":"VehicleListCard_listCard__4SFUs","addVehicleButton":"VehicleListCard_addVehicleButton__rsEBq"};